import { Action, createReducer, on } from '@ngrx/store';
import { ResourceState, intialState } from './resource.state';

import * as ResourceActions from './resource.actions';
import { ResourceUploadStatus } from './models';

const resourceReducer = createReducer(
  intialState,
  on(
    ResourceActions.fetchResourceItemsSuccess,
    (state, { resourceResponse }) => {
      const { docs } = resourceResponse;
      return {
        ...state,
        resourceItems: docs,
      };
    }
  ),
  on(ResourceActions.uploadUrlResource, (state) => ({
    ...state,
    urlUploadPending: true,
    urlUploadError: null,
    urlUploadSuccess: false,
  })),
  on(ResourceActions.uploadUrlResourceSuccess, (state, { resourceId }) => ({
    ...state,
    urlUploadPending: false,
    urlUploadSuccess: true,
    pendingResourceIds: [...state.pendingResourceIds, resourceId],
  })),
  on(ResourceActions.uploadUrlResourceFailed, (state, { error }) => ({
    ...state,
    urlUploadPending: false,
    urlUploadError:
      error?.error ?? error?.message ?? 'Failed to submit URL resource.',
  })),
  on(ResourceActions.singleResourceStatusUpdated, (state, { resource }) => {
    const existingIndex = state.resourceItems.findIndex(
      (r) => r._id === resource._id
    );
    const resourceItems =
      existingIndex >= 0
        ? state.resourceItems.map((r) =>
            r._id === resource._id ? resource : r
          )
        : [...state.resourceItems, resource];

    const isTerminal =
      resource.uploadStatus === ResourceUploadStatus.COMPLETED ||
      resource.uploadStatus === ResourceUploadStatus.FAILED;

    const pendingResourceIds = isTerminal
      ? state.pendingResourceIds.filter((id) => id !== resource._id)
      : state.pendingResourceIds;

    return { ...state, resourceItems, pendingResourceIds };
  }),
  on(ResourceActions.stopPollingSingleResource, (state, { resourceId }) => ({
    ...state,
    pendingResourceIds: state.pendingResourceIds.filter(
      (id) => id !== resourceId
    ),
  }))
);

export function reducer(state: ResourceState | undefined, action: Action) {
  return resourceReducer(state, action);
}
